import { getItemDetails } from "../../utils/APICalls/APICalls";
import { isNumber } from "../../utils/help/maths/maths";
import { ItemType } from "../../utils/types";
import { setCartDrawerState } from "../redux/slices/drawers";
import {
  setEditItemIndex,
  setItemDialogDetails,
  setModal,
} from "../redux/slices/modalSlice";
import { CartItemType } from "../redux/types/CartLoyaltyV2Types";
import { useAppDispatch } from "./useReduxHooks";

export const useModalHook = () => {
  const dispatch = useAppDispatch();

  const renderWebViewItem = async (
    itemId: number,
    editIndex?: number,
    isFreeItem?: boolean,
    offerId?: number,
    subItemId?: number,
    item?: CartItemType,
    isPartOfOffer?: boolean,
    loyaltyOfferId?: string,
    isEditingOfferItem?: boolean
  ) => {
    const res = await getItemDetails(itemId);
    if (isFreeItem) {
      res.data.isFreeItem = true;
    }
    dispatch(setCartDrawerState(false));
    if (isNumber(editIndex)) {
      dispatch(setEditItemIndex(editIndex!));
    } else {
      dispatch(setEditItemIndex(null as unknown as number));
    }
    dispatch(setItemDialogDetails(res.data as unknown as ItemType));
    handleModal(true, "ItemDialog/ItemDialog", {
      componentProps: {
        offerId,
        subItemId,
        item,
        isPartOfOffer,
        loyaltyOfferId,
        isEditingOfferItem,
      },
    });
  };

  const handleModal = (isOpen: boolean, component: string, options: {}) => {
    if (isOpen === false) {
      dispatch(setModal({ isOpen: false, component: null, options }));
      document.body.classList.remove("overflow-hidden");
    } else {
      dispatch(setModal({ isOpen: true, component: component, options }));
      document.body.classList.add("overflow-hidden");
    }
  };

  return { handleModal, renderWebViewItem };
};
